export * from "./produto-detalhes-saldo.component";
